import type { BunOptions } from "@sentry/bun";
import type { BrowserOptions } from "@sentry/react";

import { dropExpectedErrorsBeforeSend } from "./expected-errors";

export type CommonSentryConfig = BunOptions & BrowserOptions;
export type CommonSentryConfigInput = {
  dsn: string;
  environment: string;
  version: string;
};

export function getCommonSentryConfig({
  dsn,
  environment,
  version,
}: CommonSentryConfigInput): CommonSentryConfig {
  return {
    dsn,
    environment,
    release: `blis@${version}`,

    sendDefaultPii: true,
    enableLogs: true,
    attachStacktrace: true,

    tracesSampleRate: 1.0,

    ignoreTransactions: ["/api/tunnel"],

    // Drop expected client-error exceptions (NOT_FOUND, UNAUTHORIZED,
    // FORBIDDEN, BAD_REQUEST, CONFLICT, ...) before they leave the SDK.
    // These would otherwise flood Sentry via `Sentry.trpcMiddleware`,
    // which auto-captures everything thrown out of a tRPC procedure.
    beforeSend: dropExpectedErrorsBeforeSend,
  };
}
